// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__NqCo1","inner":"Footer_inner__JR4bd","text":"Footer_text__xIHeB","privacyLink":"Footer_privacyLink__Unr0A"};